export const SITE_URL = process.env.REACT_APP_SITE_URL || "";

export const BUSINESS = {
  name: "District Gaslight",
  street: "1738 14th St NW",
  city: "Washington",
  region: "DC",
  zip: "20009",
  addressLine: "1738 14th St NW, Washington, DC 20009",
  neighborhood: "Logan Circle · 14th Street",
  phone: "(202) 652-1567",
  phoneHref: "tel:+12026521567",
  email: "birhansal47@gmail.com",
  instagram: "https://www.instagram.com/districtgaslightdc/",
  profiles: [
    { label: "Google Maps", href: "https://www.google.com/maps/place/District+Gaslight/data=!4m2!3m1!1s0x0:0xbacb6534228d444d?sa=X&ved=1t:2428&ictx=111" },
    { label: "Instagram", href: "https://www.instagram.com/districtgaslightdc/" },
    { label: "Dutchie", href: "https://dutchie.com/dispensary/district-gaslight-retail" },
    { label: "Tokers Guide", href: "https://www.tokersguide.com/washington-dc-dispensaries/district-gas-light" },
    { label: "MapQuest", href: "https://www.mapquest.com/us/district-of-columbia/district-gaslight-431381315" },
  ],
  mapsUrl:
    "https://www.google.com/maps/place/District+Gaslight/data=!4m2!3m1!1s0x0:0xbacb6534228d444d?sa=X&ved=1t:2428&ictx=111",
  mapEmbed:
    "https://www.google.com/maps?q=District+Gaslight,+1738+14th+St+NW,+Washington,+DC+20009&output=embed",
  hoursShort: "Open daily from 10 AM · Late Fri & Sat",
  hours: [
    ["Monday", "10:00 AM – 9:00 PM"],
    ["Tuesday", "10:00 AM – 9:00 PM"],
    ["Wednesday", "10:00 AM – 9:00 PM"],
    ["Thursday", "10:00 AM – 10:00 PM"],
    ["Friday", "10:00 AM – 11:00 PM"],
    ["Saturday", "10:00 AM – 11:00 PM"],
    ["Sunday", "10:00 AM – 10:00 PM"],
  ],
  entrySteps: [
    "Find 1738 14th St NW — we're right next to Chicken + Whiskey.",
    "Take the first door on the left and head up the stairs.",
    "Ring the doorbell and our team will welcome you in.",
  ],
  arrival: [
    { img: "/img/storefront.webp", alt: "Street view of 1738 14th St NW with the Chicken + Whiskey storefront", title: "Find Chicken + Whiskey", text: "We're at 1738 14th St NW, right next to Chicken + Whiskey." },
    { img: "/img/entrance.webp", alt: "The staircase leading up to District Gaslight", title: "Head up the stairs", text: "Take the first door on the left and walk up the stairs." },
    { img: "/img/stairs-2.webp", alt: "District Gaslight reception lounge with the logo on a lime green wall", title: "Ring the bell", text: "Ring the doorbell at the top and our team will let you in." },
  ],
  dcCardUrl: "https://myabca.dc.gov/s/login/SelfRegister?language=en_US",
  nonDcCardUrl: "https://myabca.dc.gov/s/unauthenticated-non-dc-form?language=en_US",
};

export const DUTCHIE = {
  menuId: "dutchie--embed__script",
  menuSrc: "https://dutchie.com/api/v2/embedded-menu/67cf10d9990fdea467561817.js?menuType=med",
  carouselId: "dutchie--carousel-embed-ef213cf3-5f75-4b53-8358-6c0e6c37cde0__script",
  carouselSrc:
    "https://dutchie.com/api/v3/embedded-menu/67cf10d9990fdea467561817/carousels/ef213cf3-5f75-4b53-8358-6c0e6c37cde0.js?routeRoot=https%3A%2F%2Fdistrictgaslight.com%2Fshop-all%3Fdtche%255Bcategory%255D%3Dedibles",
};

export const shopCategoryUrl = (slug) => `/shop-all?dtche%5Bcategory%5D=${slug}`;

export const CATEGORIES = [
  { slug: "flower", name: "Flower", note: "Whole-bud, by the gram and up", img: "/img/hero-bud.webp", alt: "Cannabis flower bud against a dark background" },
  { slug: "pre-rolls", name: "Pre-Rolls", note: "Rolled, ready, no fuss", img: "/img/preroll.webp", alt: "A single pre-rolled cannabis joint on a dark surface" },
  { slug: "concentrates", name: "Concentrates", note: "Resin, wax and live extracts", img: "/img/concentrates.webp", alt: "Small glass jar holding golden cannabis concentrate" },
  { slug: "edibles", name: "Edibles", note: "Gummies, chocolates and more", img: "/img/edibles.webp", alt: "Assorted colourful gummies spread on a table" },
  { slug: "topicals", name: "Topicals", note: "Balms and lotions", img: "/img/topicals.webp", alt: "Open jar of topical balm beside a cannabis leaf" },
  { slug: "accessories", name: "Accessories", note: "Glass, papers and gear", img: "/img/store-4.webp", alt: "Rolling papers and cones on display at District Gaslight" },
];

export const NAV = [
  { to: "/shop-all", label: "Shop" },
  { to: "/special-deals", label: "Deals" },
  { to: "/medical-card", label: "Medical Card" },
  { to: "/areas-we-serve", label: "Areas Served" },
  { to: "/about", label: "About" },
  { to: "/location", label: "Visit" },
  { to: "/faq", label: "FAQ" },
];

export const FAQS = [
  { cat: "About", q: "Is District Gaslight a licensed dispensary?", a: "Yes. District Gaslight is a medical cannabis retailer licensed by DC's Alcoholic Beverage and Cannabis Administration (ABCA).", links: [{ to: "/medical-card", label: "View our ABCA license" }] },
  { cat: "Visiting", q: "Where is District Gaslight located?", a: "We're at 1738 14th St NW, Washington, DC 20009, right next to Chicken + Whiskey. Take the first door on the left, head up the stairs and ring the doorbell.", links: [{ to: "/location", label: "Map & directions" }, { to: "/areas-we-serve", label: "Directions from your neighborhood" }] },
  { cat: "Visiting", q: "What are your store hours?", a: "We're open every day from 10:00 AM. We close at 9:00 PM Monday–Wednesday, 10:00 PM Thursday and Sunday, and 11:00 PM Friday and Saturday." },
  { cat: "Eligibility", q: "What do I need to shop at District Gaslight?", a: "Bring a valid government-issued photo ID showing you are 21 or older, plus your medical cannabis patient registration. DC residents 21+ can self-certify online; visitors can use ABCA's non-DC form or a valid medical cannabis card from their home state.", links: [{ to: "/medical-card", label: "How to get a medical card" }] },
  { cat: "Eligibility", q: "How do DC residents get a medical cannabis card?", a: "Adults 21+ can self-certify online through the official ABCA portal (myabca.dc.gov) — no doctor's visit needed. Once your registration is active, you can shop with us in store or order online.", links: [{ to: "/medical-card", label: "Medical card guide" }, { to: "/shop-all", label: "Shop the live menu" }] },
  { cat: "Eligibility", q: "Can I shop if I don't live in DC?", a: "Yes. Visitors can register through ABCA's non-DC resident form at myabca.dc.gov, or use a valid medical cannabis ID from their home state.", links: [{ to: "/medical-card", label: "Visitor registration steps" }, { to: "/areas-we-serve", label: "Maryland & Virginia visitors" }] },
  { cat: "Ordering", q: "Do I need to order online?", a: "No. Our team can help you choose in store. If you already know what you want, ordering ahead online reserves it for you before you arrive.", links: [{ to: "/shop-all", label: "Order ahead" }, { to: "/special-deals", label: "Today's deals" }] },
  { cat: "Ordering", q: "How do I order online?", a: "Open our Shop page, browse by category or search the live menu, add items to your cart and check out. The fulfillment options available to you are shown at checkout.", links: [{ to: "/shop-all", label: "Open the Shop page" }] },
  { cat: "Ordering", q: "Are the prices and stock on the menu up to date?", a: "Yes. Our online menu is powered by Dutchie and pulls pricing and availability directly from our live inventory." },
  { cat: "Ordering", q: "What products do you carry?", a: "Our menu covers flower, pre-rolls, concentrates, edibles, topicals and accessories. Selection changes with inventory, so check the live menu for what's in stock today.", links: [{ to: "/shop-all?dtche%5Bcategory%5D=flower", label: "Flower" }, { to: "/shop-all?dtche%5Bcategory%5D=pre-rolls", label: "Pre-Rolls" }, { to: "/shop-all?dtche%5Bcategory%5D=concentrates", label: "Concentrates" }, { to: "/shop-all?dtche%5Bcategory%5D=edibles", label: "Edibles" }, { to: "/shop-all?dtche%5Bcategory%5D=topicals", label: "Topicals" }, { to: "/shop-all?dtche%5Bcategory%5D=accessories", label: "Accessories" }] },
  { cat: "Payment", q: "What payment methods do you accept?", a: "Accepted payment methods for online orders are shown at checkout. For in-store payment options, please call us at (202) 652-1567 before your visit." },
  { cat: "About", q: "How can I contact District Gaslight?", a: "Call us at (202) 652-1567, email birhansal47@gmail.com, or message us on Instagram at @districtgaslightdc." },
];

export const DEALS = [
  { key: "mon", days: [1], day: "Monday", title: "10% off", note: "Select items" },
  { key: "tue", days: [2], day: "Tuesday", title: "Buy 1, Get 1 Free", note: "Select items" },
  { key: "wed", days: [3], day: "Wednesday", title: "5% off", note: "Select items" },
  { key: "thu", days: [4], day: "Thursday", title: "Special gift", note: "Select items" },
  { key: "sun", days: [0], day: "Sunday", title: "10% off", note: "Select items" },
];

export const HAPPY_HOUR = { title: "Happy Hour", when: "Monday – Thursday, 4 – 8 PM", offer: "$10 pre-rolls" };

export const PAGES = {
  card: {
    title: "Get a DC Medical Cannabis Card: Self-Certify | District Gaslight",
    description: "How to register for medical cannabis in DC. Residents 21+ can self-certify online through ABCA; visitors use the non-DC form. Then shop at District Gaslight.",
  },
  deals: {
    title: "Weekly Cannabis Deals & Happy Hour | District Gaslight, DC",
    description: "Weekly specials at District Gaslight on 14th St NW: 10% off Mondays and Sundays, BOGO Tuesdays, 5% off Wednesdays, a special gift Thursdays and $10 pre-roll happy hour Mon–Thu 4–8 PM.",
  },
  home: {
    title: "District Gaslight | Medical Cannabis Dispensary on 14th St NW, DC",
    description: "ABCA-licensed medical cannabis dispensary at 1738 14th St NW in Logan Circle. Browse the live menu, order ahead for pickup. Open daily from 10 AM.",
  },
  shop: {
    title: "Shop the Live Cannabis Menu | District Gaslight, Washington DC",
    description: "Browse flower, pre-rolls, concentrates, edibles, topicals and accessories with live pricing and stock. Order ahead from District Gaslight on 14th St NW.",
  },
  about: {
    title: "About District Gaslight | Boutique Medical Dispensary in DC",
    description: "Meet District Gaslight, an ABCA-licensed medical cannabis dispensary upstairs on 14th Street NW. Learn how we help patients shop with confidence.",
  },
  location: {
    title: "Location, Hours & Directions | District Gaslight, 14th St NW DC",
    description: "Find District Gaslight at 1738 14th St NW, Washington, DC 20009, next to Chicken + Whiskey. Open daily from 10 AM, until 11 PM Fri–Sat. Call (202) 652-1567.",
  },
  faq: {
    title: "Dispensary FAQ: Medical Cards, Ordering & Hours | District Gaslight",
    description: "Answers on DC medical cannabis cards, out-of-state visitors, ordering online, store hours and finding District Gaslight on 14th Street NW.",
  },
  legal: {
    title: "Legal, Privacy & Compliance | District Gaslight",
    description: "Age requirements, privacy, health disclaimers and site terms for District Gaslight, a licensed medical cannabis retailer in Washington, DC.",
  },
};
